<template lang="pug">
    .cart-row(v-if="isAuthenticated")
        .wrapper
            .left
                span.customer(v-if="member") {{ member.name }}
            .right
                //- button(@click="clearCart") CLEAR CART
                router-link.button.is-primary.is-default.checkout(v-if="checkoutRoute && qty" :to="checkoutRoute")
                    span.icon
                        i.fas.fa-shopping-cart
                    span Checkout
                //- button.button.is-success.is-default.save-cart(@click="saveToDatabase")
                //-     span.icon
                //-         i.fas.fa-save
                //-     span Save Cart
                .cart-summary(v-if="qty")
                    span.icon.is-medium
                        i.fas.fa-shopping-cart
                    span.pill(v-if="qty > 0 && qty < 100") {{ qty }}
                    span.pill.much(v-else-if="qty > 0 && qty >= 100")
                        span.limited 99+
                        span.full {{ qty }}
                    span.price {{ price }}
</template>

<script>

import { get, cloneDeep, each } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { moneyFormat } from '@/filters'

export default {
    name: "CartRow",
    computed: {
        qty() {
            return get(this.cart, 'qty') || 0
        },
        tax() {
            const tax = get(this.cart, 'tax') || 0

            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'
            return moneyFormat(tax, code)
        },
        price() {
            let sum = get(this.cart, 'sum') || 0

            if (get(this.customer, 'show_net_prices')) {
                const tax = get(this.cart, 'tax') || 0
                sum = sum - tax
            }

            const code = get(this.customer, 'customerGroup.currency.iso4217') || 'EUR'
            return moneyFormat(sum, code)
        },
        checkoutRoute() {
            let path
            this.cms.menus.forEach(menu => {
                const item = menu.menuItems.find(item => _.get(item, 'page.view') === 'Checkout')
                if (item && item.path && ! path) {
                    path = item.path
                    return
                }
            })
            return path
        },
        ...mapGetters({
            member: 'auth/member',
            isAuthenticated: 'auth/isAuthenticated',
            // defaultTax: 'defaultTax',
            cms: 'CMS',
            customer: 'shop/customer',
            defaultCustomerGroup: 'defaultCustomerGroup',
            cart: 'shop/cart',
        })
    },
    methods: {
        ...mapActions({
            clearCart: 'shop/clearCart'
        }),
    }
}
</script>
<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins";
    .cart-row
        position: fixed
        bottom: 0
        left: 0
        width: 100%
        height: 65px
        background-color: #fff
        border-top: 1px solid #000
        z-index: 1
        .wrapper
            display: flex
            justify-content: space-between
            padding: 15px 0 0 5em
            width: calc((100vw - ((100vh - 65px) * (9 / 16)) - 5em)
            .left
                .customer
                    line-height: 36px
                    font-weight: bold
            .right
                display: flex
                flex-direction: row
                .checkout
                    margin-right: 25px
                    span
                        color: white
            .cart-summary
                position: relative
                line-height: 36px
                height: 36px
                .pill
                    position: relative
                    line-height: 1
                    background: red
                    top: -10px
                    left: -15px
                    font-weight: bold
                    padding: 1px 3px
                    border-radius: 10px
                    color: white
                    font-size: .85rem
                    margin-right: -10px
                    cursor: default
                    &.much
                        .limited
                            display: initial
                        .full
                            display: none
                        &:hover
                            .limited
                                display: none
                            .full
                                display: initial
        +mobile
            height: unset
            .wrapper
                padding-left: 25px
</style>
